module.exports = __webpack_public_path__ + "img/tour-free_pr.3ba0a832.png";